import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/_helpers';
import { Role } from '@app/_models';
import { OrderUnlockComponent } from '@app/features';

import { HomeComponent } from './home/home.component';
import { VolantiniComponent } from './b2c/volantini/volantini.component';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const promoModule = () => import('./promo/promo.module').then(x => x.PromoModule); // B2B (still using old name)
const b2cModule = () => import('./b2c/b2c.module').then(x => x.B2cModule); // B2C
const usersModule = () => import('./users/users.module').then(x => x.UsersModule);

// TO BE MADE
//const usersModule = () => import('./users/users.module').then(x => x.UsersModule);

const routes: Routes = [

  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'account', loadChildren: accountModule },
  {
    path: 'b2b',
    loadChildren: promoModule,
    canActivate: [AuthGuard],
    data: { roles: [Role.b2b, Role.admin] }
  },
  {
    path: 'ordini',
    component: OrderUnlockComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.b2b, Role.admin] }
  },
  {
    path: 'b2c',
    loadChildren: b2cModule,
    canActivate: [AuthGuard],
    data: { roles: [Role.b2c, Role.admin] }
  },
 
  {
    path: 'utenti',
    loadChildren: usersModule,
    canActivate: [AuthGuard],
    data: { roles: [Role.admin] }
  },

  /* {
    path: 'volantini',
    component: VolantiniComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.volantino,Role.admin] }
  }, */


  // role based auth guard -> for better controlo and avoid URL editing by user (it is a further security if we forget a check in backend)
  //https://medium.com/echohub/angular-role-based-routing-access-with-angular-guard-dbecaf6cd685

  // prenotazioni
  // banner

  // che altro?

  //add user mgmt (?)

  // default redirect
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    { enableTracing: false }
    )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
